import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IExpense } from "src/domain/entities"
import { ExpenseListView } from "."

interface Props {
	list: IExpense[]
	isLoading: boolean
	onUpdate: (expense: IExpense) => void
	onDelete: (expense: IExpense) => void
	onAddClick: () => void
}

export const ExpenseListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No expenses found." onAddClick={onAddClick} />
	}

	return <ExpenseListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
